import { Coin } from "../../cosmos/base/v1beta1/coin";
import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
function createBaseMsgSetAirdropAllocations() {
  return {
    allocator: "",
    airdropIdentifier: "",
    users: [],
    weights: []
  };
}
export const MsgSetAirdropAllocations = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.allocator !== "") {
      writer.uint32(10).string(message.allocator);
    }
    if (message.airdropIdentifier !== "") {
      writer.uint32(18).string(message.airdropIdentifier);
    }
    for (const v of message.users) {
      writer.uint32(26).string(v);
    }
    for (const v of message.weights) {
      writer.uint32(34).string(v);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetAirdropAllocations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.allocator = reader.string();
          break;
        case 2:
          message.airdropIdentifier = reader.string();
          break;
        case 3:
          message.users.push(reader.string());
          break;
        case 4:
          message.weights.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$allocator, _object$airdropIdenti, _object$users, _object$weights;
    const message = createBaseMsgSetAirdropAllocations();
    message.allocator = (_object$allocator = object.allocator) !== null && _object$allocator !== void 0 ? _object$allocator : "";
    message.airdropIdentifier = (_object$airdropIdenti = object.airdropIdentifier) !== null && _object$airdropIdenti !== void 0 ? _object$airdropIdenti : "";
    message.users = ((_object$users = object.users) === null || _object$users === void 0 ? void 0 : _object$users.map(e => e)) || [];
    message.weights = ((_object$weights = object.weights) === null || _object$weights === void 0 ? void 0 : _object$weights.map(e => e)) || [];
    return message;
  }
};
function createBaseMsgSetAirdropAllocationsResponse() {
  return {};
}
export const MsgSetAirdropAllocationsResponse = {
  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgSetAirdropAllocationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseMsgSetAirdropAllocationsResponse();
    return message;
  }
};
function createBaseMsgClaimFreeAmount() {
  return {
    user: ""
  };
}
export const MsgClaimFreeAmount = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.user !== "") {
      writer.uint32(10).string(message.user);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClaimFreeAmount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.user = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$user;
    const message = createBaseMsgClaimFreeAmount();
    message.user = (_object$user = object.user) !== null && _object$user !== void 0 ? _object$user : "";
    return message;
  }
};
function createBaseMsgClaimFreeAmountResponse() {
  return {
    claimedAmount: []
  };
}
export const MsgClaimFreeAmountResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.claimedAmount) {
      Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgClaimFreeAmountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.claimedAmount.push(Coin.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$claimedAmount;
    const message = createBaseMsgClaimFreeAmountResponse();
    message.claimedAmount = ((_object$claimedAmount = object.claimedAmount) === null || _object$claimedAmount === void 0 ? void 0 : _object$claimedAmount.map(e => Coin.fromPartial(e))) || [];
    return message;
  }
};
function createBaseMsgCreateAirdrop() {
  return {
    distributor: "",
    identifier: "",
    startTime: Long.UZERO,
    duration: Long.UZERO,
    denom: ""
  };
}
export const MsgCreateAirdrop = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.distributor !== "") {
      writer.uint32(10).string(message.distributor);
    }
    if (message.identifier !== "") {
      writer.uint32(18).string(message.identifier);
    }
    if (!message.startTime.isZero()) {
      writer.uint32(24).uint64(message.startTime);
    }
    if (!message.duration.isZero()) {
      writer.uint32(32).uint64(message.duration);
    }
    if (message.denom !== "") {
      writer.uint32(42).string(message.denom);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateAirdrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.distributor = reader.string();
          break;
        case 2:
          message.identifier = reader.string();
          break;
        case 3:
          message.startTime = reader.uint64();
          break;
        case 4:
          message.duration = reader.uint64();
          break;
        case 5:
          message.denom = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$distributor, _object$identifier, _object$denom;
    const message = createBaseMsgCreateAirdrop();
    message.distributor = (_object$distributor = object.distributor) !== null && _object$distributor !== void 0 ? _object$distributor : "";
    message.identifier = (_object$identifier = object.identifier) !== null && _object$identifier !== void 0 ? _object$identifier : "";
    message.startTime = object.startTime !== undefined && object.startTime !== null ? Long.fromValue(object.startTime) : Long.UZERO;
    message.duration = object.duration !== undefined && object.duration !== null ? Long.fromValue(object.duration) : Long.UZERO;
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    return message;
  }
};
function createBaseMsgCreateAirdropResponse() {
  return {};
}
export const MsgCreateAirdropResponse = {
  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgCreateAirdropResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseMsgCreateAirdropResponse();
    return message;
  }
};
function createBaseMsgDeleteAirdrop() {
  return {
    distributor: "",
    identifier: ""
  };
}
export const MsgDeleteAirdrop = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.distributor !== "") {
      writer.uint32(10).string(message.distributor);
    }
    if (message.identifier !== "") {
      writer.uint32(18).string(message.identifier);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteAirdrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.distributor = reader.string();
          break;
        case 2:
          message.identifier = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$distributor2, _object$identifier2;
    const message = createBaseMsgDeleteAirdrop();
    message.distributor = (_object$distributor2 = object.distributor) !== null && _object$distributor2 !== void 0 ? _object$distributor2 : "";
    message.identifier = (_object$identifier2 = object.identifier) !== null && _object$identifier2 !== void 0 ? _object$identifier2 : "";
    return message;
  }
};
function createBaseMsgDeleteAirdropResponse() {
  return {};
}
export const MsgDeleteAirdropResponse = {
  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgDeleteAirdropResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseMsgDeleteAirdropResponse();
    return message;
  }
};